import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Image from '@/components/base/Image'
import MediaParallax from '@/components/base/MediaParallax'
import Motion from '@/components/base/Motion'

import { doubleImg } from './animations'
import { cn } from '@/lib/utils'
import { WPImage, WPPageData } from '@/types'

export type DoubleImgProps = HTMLAttributes<HTMLElement> &
  Partial<{
    items: WPImage[]
    theme: WPPageData['acf']['theme']
  }>

const DoubleImg = ({ items, theme, ...props }: DoubleImgProps) => {
  return items && items.length > 0 ? (
    <Motion animation={doubleImg}>
      {(motionRef) => (
        <section
          ref={motionRef}
          {...props}
          className={cn([
            {
              'bg-dark-100 text-dark-500': theme === 'light',
              'bg-dark-600 text-white': theme === 'dark'
            }
          ])}
        >
          <Container>
            <Grid>
              {items.map((item, index) => (
                <div
                  key={item.id}
                  className={cn([
                    {
                      'col-span-2 md:col-span-2 md:col-start-2': index === 0,
                      'col-span-2 md:col-span-3': index === 1
                    }
                  ])}
                >
                  <MediaParallax
                    className={cn([
                      {
                        'aspect-h-1 aspect-w-1': index === 0,
                        'aspect-h-6 aspect-w-4 md:aspect-h-1 md:aspect-w-1':
                          index === 1
                      }
                    ])}
                  >
                    {(ref: React.RefObject<HTMLElement>) => (
                      <Image
                        // @ts-ignore
                        ref={ref}
                        source={item}
                        size="large"
                        fit="cover"
                        fill
                        data-motion-image
                      />
                    )}
                  </MediaParallax>
                </div>
              ))}
            </Grid>
          </Container>
        </section>
      )}
    </Motion>
  ) : null
}

export default DoubleImg
